import React from 'react';
import PropTypes from 'prop-types';

import { RadioGroup as MuiRadioGroup } from '@material-ui/core';

const RadioGroup = ({ children, ...rest }) => {
  return (
    <MuiRadioGroup
      {...rest}
    >
      { children }
    </MuiRadioGroup>
  )
}

RadioGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/base/RadioGroup/RadioGroup.js